import { useState } from "react";
import { pdfjs, Document, Page } from "react-pdf";

import FieldLoader from "../Atom/FieldLoader";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Typography } from "@mui/material";

import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "./style/PdfViewer.css";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  // Use legacy for old browsers compatibility
  "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export default function PdfViewer({
  pdfFile,
  onLoadError,
  onLoadSuccess,
  errorMessage,
}: any) {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
    if (typeof onLoadSuccess === "function") {
      onLoadSuccess();
    }
  }

  function onDocumentLoadError() {
    if (typeof onLoadError === "function") {
      onLoadError();
    }
  }

  return (
    <Box sx={{ overflow: "clip" }}>
      <Document
        file={pdfFile}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={<Transition loading={true} />}
        error={<Transition loading={false} errorMessage={errorMessage} />}
        noData={<Transition loading={false} errorMessage={errorMessage} />}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <Page
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            width={window.screen.width}
          />
        ))}
      </Document>
    </Box>
  );
}

function Transition({ loading, errorMessage }: any) {
  const transitionStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  };

  return loading ? (
    <Box sx={transitionStyle}>
      <FieldLoader />
    </Box>
  ) : (
    <Box sx={transitionStyle}>
      <ErrorIcon color="error" fontSize="large" />
      <Typography>{errorMessage}</Typography>
    </Box>
  );
}
